import { IAdjustmentProfileStoreSegment } from './adjustmentProfile.interface';

export const adjustmentProfileStoreSelector = (state: IAdjustmentProfileStoreSegment) => state.adjustmentProfile;
